import type React from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const KeyboardUpDownIcon: React.FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props} data-test-id="keyboard-up-down-icon" viewBox="0 0 32 32">
    <path d="M10 26a1 1 0 0 1-1-1V5a1 1 0 1 1 2 0v20a1 1 0 0 1-1 1Z" />
    <path d="M15.707 19.293a1 1 0 0 0-1.414 0l-5 5a1 1 0 1 0 1.414 1.414l5-5a1 1 0 0 0 0-1.414Z" />
    <path d="M4.293 19.293a1 1 0 0 1 1.414 0l5 5a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414ZM22 6a1 1 0 0 1 1 1v20a1 1 0 1 1-2 0V7a1 1 0 0 1 1-1Z" />
    <path d="M27.707 12.707a1 1 0 0 1-1.414 0l-5-5a1 1 0 0 1 1.414-1.414l5 5a1 1 0 0 1 0 1.414Z" />
    <path d="M16.293 12.707a1 1 0 0 0 1.414 0l5-5a1 1 0 0 0-1.414-1.414l-5 5a1 1 0 0 0 0 1.414Z" />
  </BaseIcon>
);
